<template>
  <div class="sidebar" :class="{ navigation_scroll: navigation_scroll }">
    <el-menu :default-active="onRoutes" mode="horizontal" active-text-color="#FFFFFF" text-color="#FFFFFF" unique-opened router>
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index" popper-class="select-down">
                <template slot="title">{{ subItem.title }}</template>
                <!-- <el-menu-item
                  v-for="(threeItem, i) in subItem.subs"
                  :key="i"
                  :index="threeItem.index"
                  >{{ threeItem.title }}
                </el-menu-item> -->
              </el-submenu>
              <el-menu-item v-else :index="subItem.index" :key="subItem.index">{{ subItem.title }}
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>

      <!-- <el-menu-item v-for="(item, key) in items" :key="key">
        {{ item.title }}
      </el-menu-item> -->
      <!-- <i class="el-icon-search"></i> -->
    </el-menu>
  </div>
</template>

<script>
import bus from "../common/bus";
export default {
  data() {
    return {
      navigation_scroll: false,
      items: [
        {
          index: "/",
          title: "Home",
        },
        {
          index: "/Browse",
          title: "Browse",
        },
        {
          index: "/Search",
          title: "Search",
        },
        {
          index: "/Tools",
          title: "Tools",
          subs: [
            { index: "/JBrowse", title: "JBrowse" },
            { index: "/Efp", title: "eFP Browser" },
            { index: "/Blast", title: "Blast" },
            { index: "/EPexplorer", title: "EPexplorer" },
          ],
        },
        {
          index: "/Download",
          title: "Download",
        },
        {
          index: "/Statistic",
          title: "Statistics",
        },
        {
          index: "/Documentation",
          title: "Documentation",
        },
        // {
        //   index: "/Resource",
        //   title: "Resource",
        // },
        {
          index: "/Submit",
          title: "Submit",
        },
        {
          index: "/Contact",
          title: "Contact",
        },
      ],
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 200) {
        this.navigation_scroll = true;
      } else if (scrollTop < 200) {
        this.navigation_scroll = false;
      }
    },
  },
};
</script>

<style>
.navigation_scroll {
  position: fixed !important;
  z-index: 999;
  top: 0;
}

.sidebar {
  width: 100%;
  position: absolute;
  height: 50px;
  bottom: 0;
  background: rgba(74, 179, 208, 1);
}

.sidebar .el-icon-search {
  float: right;
  /* margin-top: 15px; */
  font-size: 30px;
  line-height: 50px;
  border-color: rgba(74, 179, 208, 1);
  color: #ffffff;
}

.sidebar .el-menu {
  width: 1240px;
  font-size: 15px;
  height: 50px;
  border: none;
  font-family: PingFang SC;
  font-weight: bold;
  margin: 0 auto;
  background: rgba(74, 179, 208, 1);
}

.el-menu .el-menu-item {
  background: rgba(74, 179, 208, 1) !important;
}

.el-menu .el-menu-item:hover {
  background: rgba(139, 182, 68, 1) !important;
}
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: rgba(139, 182, 68, 1) !important;
}

.el-menu--horizontal > .el-submenu .is_opened .el-submenu__title {
  background: rgba(139, 182, 68, 1) !important;
  color: #ffffff !important;
}

.is-active .el-submenu__title {
  background: rgba(139, 182, 68, 1) !important;
  border-bottom-color: rgba(139, 182, 68, 1) !important;
}

.el-menu .is-active {
  background: rgba(139, 182, 68, 1) !important;
  border-bottom-color: rgba(139, 182, 68, 1) !important;
}

.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  color: #ffffff !important;
}
.el-menu--popup-bottom-start {
  margin-top: 0px !important;
}
.el-menu--popup {
  padding: 0 0 !important;
}
</style>
